module.exports = __webpack_public_path__ + "fonts/texgyrepagella-bolditalic.1b0419db.otf";